import React, { useContext } from 'react'
import { useSelector } from 'react-redux'
import HistoryContext from './HistoryContext'

export default function connect () {
  return function wrapComponent (WrappedComponent) {
    if (!WrappedComponent) {
      throw new Error('HOC RouterConnect must be supplied a child component.')
    }
    return function RouterConnect (props) {
      const history = useContext(HistoryContext)
      const resolver = useSelector((state) => state.resolver)
      return (
        <WrappedComponent
          {...props}
          history={history}
          resolver={resolver}
          location={resolver.get('location')}
        />
      )
    }
  }
}

/**
 * Connects page level behaviors for seo and language to child components.
 */
// export function connect () {
//   return function wrapComponent (WrappedComponent) {
//     // eslint-disable-next-line react/prefer-stateless-function
//     class RouterConnect extends Component {
//       render () {
//         const { props, context: history } = this
//         const { resolver } = props
//         if (!WrappedComponent) return null
//         const componentProps = _assign({}, props, {
//           location: resolver.get('location'),
//           history,
//         })
//         return <WrappedComponent {...componentProps} />
//       }
//     }

//     RouterConnect.displayName = `${COMPONENT_NAME}(${getDisplayName(
//       WrappedComponent,
//     )})`

//     RouterConnect.propTypes = {
//       resolver: ImmutablePropTypes.map.isRequired,
//     }

//     RouterConnect.contextType = HistoryContext

//     return compose(
//       connectRedux(
//         state => ({
//           resolver: state.resolver,
//         }),
//       ),
//     )(RouterConnect)
//   }
// }

// export default connect

// function getDisplayName (WrappedComponent) {
//   return WrappedComponent.displayName || WrappedComponent.name || 'Component'
// }
